define('sections/upgrade/Podio.UI.Upgrade.Global',['require','translate','underscore','jquery','lib/Podio.Transport','lib/Podio.Router','lib/Podio.Routes','lib/Podio.Store','lib/Podio.UI.Modal','lib/Podio.Event.UI'],function(require) {
  var contractId;

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var transport = require('lib/Podio.Transport');
  var router = require('lib/Podio.Router');
  var routes = require('lib/Podio.Routes');
  var podioStore = require('lib/Podio.Store');
  var modal = require('lib/Podio.UI.Modal');
  var eventUI = require('lib/Podio.Event.UI');

  function onSuccessModalRouteInvoked(routeData) {
    contractId = routeData.params[0];
    modal.showLoading(t('Finalizing upgrade #upgrade.success'));

    transport.getJSON(routes.success_organization_contract_path(contractId), {}, function(responseData) {
      modal.show(responseData.data.html, { title: responseData.data.title_html, footerHtml: responseData.data.footer_html, showHandler: onModalOpened, hideHandler: onModalClosed, width: 800, className: 'upgrade-success-modal' });
    });
  }

  function onModalOpened() {
    var store = podioStore.create('invitations', true);
    var spaceUrl = store.get('space_url');
    if (!_.isUndefined(spaceUrl)) {
      $('.finish-button').attr('href', spaceUrl + '#invite/resume').find('span').text(t('Continue to your previous invitations #invite'));
    }
  }

  function onModalClosed() {
    contractId = null;
    router.goToHashRoute('');
    return true;
  }

  function onSectionMouseEnter(elmTarget, e) {
    elmTarget.find('a.button-new').removeClass('secondary').addClass('primary');
    elmTarget.addClass('active');
  }
  function onSectionMouseLeave(elmTarget, e) {
    elmTarget.find('a.button-new').removeClass('primary').addClass('secondary');
    elmTarget.removeClass('active');
  }
  function onSectionClicked(elmTarget, e) {
    if (!$(e.target).is('a')) {
      e.preventDefault();
      window.location = elmTarget.find('.button-new').attr('href');
      return false;
    }
    return true;
  }

  function onSuccessPageRouteInvoked(routeData) {
    eventUI.bind('mouseenter', '#wrapper.upgrade-success div.upgrade-success-page div.g33', onSectionMouseEnter);
    eventUI.bind('mouseleave', '#wrapper.upgrade-success div.upgrade-success-page div.g33', onSectionMouseLeave);
    eventUI.bind('click', '#wrapper.upgrade-success div.upgrade-success-page div.g33', onSectionClicked, true);
  }

  router.addHashRoute('contracts/{contract_id}/success', onSuccessModalRouteInvoked);
  router.addRoute('{org_slug}/organization/contracts/success_page', onSuccessPageRouteInvoked);

});

